export const NAMESPACE = 'KanBo/env/'
export const SET = NAMESPACE + 'SET'

const initialState = {
  instanceId: null,
  url: '',
  protocol: '',
  host: '',
  hostname: '',
  port: '',
  origin: '',
  search: '',
  pathname: '',
  hash: ''
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        ...action.payload
      }
    default: return state
  }
}

export function set (payload) {
  return {
    type: SET,
    payload
  }
}
